export function customPeriod(options: {from: UnixTimeStamp; to: UnixTimeStamp}): Period {
  const {from, to} = options;
  return {from, to};
}
